/*
 * @Author: Tina Huang
 * @Date: 2024-05-13 13:11:33
 * @LastEditors: Tina Huang
 * @LastEditTime: 2024-05-14 10:21:41
 * @Description:
 */

import { createDairy } from '@/server'
import { Button, Col, Form, Input, Modal, Result, Row, Spin, notification } from 'antd'
import { dairyTypes } from '@/constants/notions'
import { useState } from 'react'
export default function Dairy() {
  const [form] = Form.useForm()
  const [tag, setTag] = useState<string[]>(['7841d70ac88b4baaaaf9b9b21bf2f1b8'])
  const [loading, setLoading] = useState(false)
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [result, setResult] = useState<any>({})
  const [api, contextHolder] = notification.useNotification()

  const handleTagsClick = (id: string) => {
    if (tag.includes(id)) {
      setTag(tag.filter((item: string) => item !== id))
    } else {
      setTag([...tag, id])
    }
  }
  const handleSubmit = () => {
    form.validateFields().then((values) => {
      const { title, content, emoji } = values
      if (!title) return
      setLoading(true)
      const params: any = {
          // debug: true,
        },
        properties: any = {
          Name: { type: 'title', value: title },
          标签: { type: 'relation', value: tag },
          字数: { type: 'number', value: title?.length + content?.length },
        }
      if (emoji) params['emoji'] = emoji
      if (content) properties['content'] = content
      params['properties'] = properties
      createDairy(params)
        .then((res) => {
          setLoading(false)
          setIsModalOpen(true)
          setResult(res)
        })
        .catch((error) => {
          setLoading(false)
          api.error({
            message: '创建失败，请重试',
          })
        })
    })
  }

  const handleView = () => {
    if (result) {
      window.open(result?.url)
      handleClose()
    }
  }

  const handleClose = () => {
    setIsModalOpen(false)
    form.resetFields()
  }

  return (
    <div className="p-4">
      {contextHolder}
      <Spin fullscreen spinning={loading}></Spin>
      <div className="flex justify-between mb-10">
        {dairyTypes.map((item) => (
          <div
            className={`w-auto p-5 rounded-lg cursor-pointer ${tag.includes(item.id) ? 'bg-black text-white' : 'bg-neutral-100'}`}
            key={item.id}
            onClick={() => handleTagsClick(item.id)}
          >
            {item.title}
          </div>
        ))}
      </div>
      <Form form={form}>
        <Row align="middle">
          <Col span={3}>
            <Form.Item name="emoji">
              <Input placeholder="请输入Emoji" />
            </Form.Item>
          </Col>
          <Col span={1}>
            <Form.Item className="text-center">+</Form.Item>
          </Col>
          <Col span={20}>
            <Form.Item name="title">
              <Input placeholder="请输入标题" />
            </Form.Item>
          </Col>
        </Row>
        <Form.Item name="content">
          <Input.TextArea placeholder="请输入日记正文" rows={20} />
        </Form.Item>
        <Button type="primary" block onClick={handleSubmit}>
          保存日记
        </Button>
      </Form>
      <Modal title="Great!" open={isModalOpen} footer="" onCancel={handleClose}>
        <Result
          status="success"
          title="日记添加成功!"
          subTitle={form.getFieldValue('title')}
          extra={[
            <Button type="primary" key="console" onClick={handleView}>
              前往Notion查看
            </Button>,
          ]}
        />
      </Modal>
    </div>
  )
}
